import api from './api'
export const unionAPI = {
  getRecMoneyListByMonthAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetRecMoneyListByMonthAsync`, params)
  },
  exportCardRecMoneyData: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/ExportCardRecMoneyData`, params)
  },
  getPayCouponAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetPayCouponAsync`, params)
  },
  getPayDetalListAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetPayDetalListAsync`, params)
  },
  getMonthEveryDayAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetMonthEveryDayAsync`, params)
  },
  getParkingPayDayAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetParkingPayDayAsync`, params)
  },
  getZBParkingPayDayAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetZBParkingPayDayAsync`, params)
  },
  getCouponDayAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetCouponDayAsync`, params)
  },
  getCouponAndCardDayAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetCouponAndCardDayAsync`, params)
  },
  getParkingPayMonthAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetParkingPayMonthAsync`, params)
  },
  getCardRecAndCntByMonthAsync: (params) => {
    return api.post(`/CloudParkAPI/UnionReport/GetCardRecAndCntByMonthAsync`, params)
  },
  getPaymentTypeList: (params) => {
    return api.post(`/CloudParkAPI/PCUser/GetPaymentTypeList`, params)
  },
  getMobDetalListAsync: (params) => {
    return api.post(`/CloudParkAPI/MobReport/GetPayDetalListAsync`, params)
  },
  getPassWorkListAsync: (params) => {
    return api.post(`/CloudParkAPI/MobReport/GetPassWorkListAsync`, params)
  },
  getBGGCPayDetalListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetPayDetalListAsync`, params)
  },
  getBGGCChargePreExeListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetChargePreExeListAsync`, params)
  },
  getBGGCPassWorkListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetPassWorkListAsync`, params)
  },
  getBGGCCardPayDetalListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetCardPayDetalListAsync`, params)
  },
  getSumRechargeCardListAsyncAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetSumRechargeCardListAsync`, params)
  },
  getCashPaymentDetailList: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetCashPaymentDetailList`, params)
  },
  getBGGCDayPassWorkListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetDayPassWorkListAsync`, params)
  },
  getBGGCMonPassWorkListAsync: (params) => {
    return api.post(`/CloudParkAPI/BGGCReport/GetMonPassWorkListAsync`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/unionReport.js